import { AccountFragment } from 'types/api/account.types';

export const getName = (account: AccountFragment | undefined) =>
  [account?.firstName, account?.middleName, account?.lastName]
    .filter(Boolean)
    .join(' ');

export const getInitials = (account: AccountFragment | undefined) =>
  `${account?.firstName?.charAt(0)}${account?.lastName?.charAt(0)}`;

export const isMissingRequiredFields = (
  account: AccountFragment | undefined,
  isEmbedded?: boolean,
) => {
  // if embedded, we don't need to check for required fields. In our React Native application these fields are optional
  // because Apple says: The app requires users to provide personal information when registering that is not directly relevant to the app's core functionality.
  if (isEmbedded) return false;

  // some fields where added later on, but are required.
  if (!account?.gender || !account?.city) return true;

  return false;
};
